import { useMutation } from '@apollo/client'
import { useEffect } from 'react'

import { FEATURE_CODES } from '../constants'
import { UseDocumentFeatureMutation } from '../helpers'

type DocumentType =
  | {
      docId: number
      artifact: string
    }
  | null
  | undefined

export const useConsumeCredits = (
  shouldConsumeViewCredits: boolean | undefined,
  document: DocumentType | undefined
) => {
  const [consumeViewCredits] = useMutation(UseDocumentFeatureMutation)
  useEffect(() => {
    if (shouldConsumeViewCredits && document) {
      consumeViewCredits({
        variables: {
          input: {
            docId: document.docId,
            artifact: document.artifact,
            feature: FEATURE_CODES.VIEW_LR_CONTENT_1000,
          },
        },
      }).catch((err) => {
        console.error(err)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldConsumeViewCredits, document?.docId, consumeViewCredits])
}
